import React, { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { Container, Tabs } from '@mui/material';
import LinkTab from 'components/common/LinkTab';
import { a11yProps } from 'components/mui/Tabs';
import { StockStatus } from 'models/StockModel';
import Ready from 'modules/cars/tables/Ready';
import Shipped from 'modules/cars/tables/Shipped';
import Common from 'modules/cars/tables/Common';
import Canceled from 'modules/cars/tables/Canceled';


const tabs = {
    ready: () => <Ready/>,
    shipped: () => <Shipped/>,
    received: () => <Common status={StockStatus.Received}/>,
    canceled: () => <Canceled status={StockStatus.Canceled}/>,
    lost: () => <Common status={StockStatus.Lost}/>,
};

const CarsInner = () => {
    const {t} = useTranslation('cars');
    const { status = 'ready' } = useParams();

    if (!(status in tabs)) {
        return null;
    }

    return (
        <Container maxWidth={false} sx={{mt: 2}}>
            <Tabs
                variant="scrollable"
                value={status}
                aria-label="cars by status"
                sx={{mb:2}}
            >
                {Object.keys(tabs).map(tab => (
                    <LinkTab
                        key={tab}
                        value={tab}
                        label={t('status_' + tab)}
                        to={`/cars/${tab}`}
                        {...a11yProps('car-statuses', tab)}
                    />
                ))}
            </Tabs>

            {tabs[status as keyof typeof tabs]()}
        </Container>
    )
};

const CarsByStatus = () => {
    return (
        <Suspense fallback={null}>
            <CarsInner />
        </Suspense>
    )
}

export default CarsByStatus;
